export const AccountType = {
  Personal: 'Personal',
  Organisation: 'Organisation'
};
